import type React from 'react'

const AiBlocks: React.FC = () => {
  return (
    <svg
      width="112"
      height="112"
      viewBox="0 0 112 112"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="22.6"
        y="14.6"
        width="66.8"
        height="82.8"
        rx="2.4"
        stroke="#2F7FEF"
        strokeWidth="1.2"
      />
      <rect x="28" y="20" width="56" height="8" rx="1.5" fill="#2F7FEF" />
      <rect x="28" y="32" width="56" height="20" rx="1.5" fill="#AA5EEA" />
      <rect x="28" y="56" width="17" height="14" rx="1.5" fill="#2F7FEF" />
      <rect x="47.5" y="56" width="17" height="14" rx="1.5" fill="#2F7FEF" />
      <rect x="67" y="56" width="17" height="14" rx="1.5" fill="#2F7FEF" />
      <rect
        x="28"
        y="74"
        width="56"
        height="8"
        rx="1.5"
        fill="#2F7FEF"
        fillOpacity="0.4"
      />
      <rect x="28" y="86" width="56" height="6" rx="1.5" fill="#2F7FEF" />
      <path
        d="M18 4L20.4 10.6L27 13L20.4 15.4L18 22L15.6 15.4L9 13L15.6 10.6L18 4Z"
        fill="#AA5EEA"
      />
      <path
        d="M8 24L9.3 27.7L13 29L9.3 30.3L8 34L6.7 30.3L3 29L6.7 27.7L8 24Z"
        fill="#AA5EEA"
      />
    </svg>
  )
}

export default AiBlocks
